<template>
  <div class="calendar-options-data-dialog">
    <el-collapse v-model="activeNames" class="relative-setting-box">
      <el-collapse-item name="1" title="数据源">
        <div class="data-source-type mb12">
          <cx-slider :value.sync="isLocal" :options="dataOptions" :height="32" />
        </div>
        <div v-if="isLocal" class="dataSource-item" @click="goToChooseData">
          <span>进入数据管理后台 </span>
        </div>
        <data-center-choose 
          v-show="!isLocal"
          :checkStatus="checkStatus"
          :myId="ids"
          :options="options"
          :jumpDirect="true"
          @onDataCenterChange="onDataCenterChange"
          @onAfterDataCenterChoose="onAfterDataCenterChoose"
          @onBeforeDataCenterUpdate="onBeforeDataCenterUpdate"
          @onAfterDataCenterUpdate="onAfterDataCenterUpdate"
        />
      </el-collapse-item>
      <el-collapse-item name="2" title="更多">
        <auto-update-timer :isLocal="isLocal" :options="options" unit="分" />
        <div class="setting-item mt16 mb16" v-if="styleId === 2">
          <p class="">时间段设置</p>
          <div class="select_flag_div mt16">
            <div class="setting-item mt16">
              <cx-select title="开始日期" :selectOptions="flagLists" :value.sync="startDateFlag" />
            </div>
            <div class="setting-item mt16">
              <cx-select title="结束日期" :selectOptions="flagLists" :value.sync="endDateFlag" />
            </div>
          </div>
        </div>
        <div>
          <!-- <div class="getDataBtn mb16" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
          <cx-check-box  v-if="request_prefix==='bigScreen'"  :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "calendar-options-data",
  components: { autoUpdateTimer, dataCenterChoose },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      fetchEnd: false,
      flagLists: [],
      appId: null,
      isLocal: true,
      localManual: true,
      source: 1
    }
  },
  mounted() {
    if(this.options.restDataUrl && this.flagLists.length === 0){
      this.getAllData()
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenData)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    styleId() {
      return this.options.styleId
    },
    startDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "startDateFlag", "startDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startDateFlag", false)
      }
    },
    endDateFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "endDateFlag", "endDateFlag", null)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endDateFlag", false)
      }
    },
    dataOptions() {
      const options = [{ value: true, title: "本地数据" }, { value: false, title: "数据中心" }]
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    }
  },
  watch: {
    isLocal: {
      handler(newVal) {
        // 手动切换到本地数据
        if(newVal && this.localManual && this.appId && this.source !== 1) {
          this.$confirm("确定使用本地资源？", "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            dangerouslyUseHTMLString: "<p>确定使用本地资源？</p>",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          }).then(() => {
            this.$API.setLocalData({ appId: this.appId, type: "general" }).then(() => {
              this.isLocal = true
              this.source = 1
              this.$changeOptionsEV("", "dataCenterName", false, null, this.myId, true)
              this.getBaseModuleDataLoop()
            })
          }).catch((e) => {
            this.isLocal = false
          })
        }
        this.localManual = true
      }
    }
  },
  methods: {
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "general" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      // 数据自动渲染
      this.appId = appId
      window.addEventListener("storage", this.listenData)
    },
    getAllData() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          if (datas.length > 0) {
            for (let j in datas[0]) {
              if (datas[0][j] && datas[0][j].key) {
                this.flagLists.push({
                  value: j,
                  label: datas[0][j].key
                })
              }
            }
            this.getBaseModuleDataLoop()
          }
        })
        .then(restDataUrl => {
          if (restDataUrl) {
            this.restDataUrl = restDataUrl.replace("engineInstanceId", "e").replace("typeId", "t")
          }
        })
    },
    async getBaseModuleDataLoop() {
      if (this.startDateFlag === null || this.startDateFlag === null || this.flagLists.length === 0) {
        this.getAllData()
        return
      }
      let sd,
        ed,
        sf,
        ef,
        calendarValue = new Date(),
        lastDay
      let pickData = this.options.pickDate
      if (!pickData) {
        let pickerDateY = calendarValue.getFullYear()
        let pickerDateM =
          Number(calendarValue.getMonth() + 1) < 10
            ? "0" + Number(calendarValue.getMonth() + 1)
            : Number(calendarValue.getMonth() + 1)
        let pickerDateD = calendarValue.getDate() < 10 ? "0" + calendarValue.getDate() : calendarValue.getDate()
        sd = pickerDateY + "-" + pickerDateM + "-" + pickerDateD
        //获取最后一天
        var date = new Date()
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        lastDay = date.getDate()
        ed = pickerDateY + "-" + pickerDateM + "-" + lastDay
      } else {
        let arr1 = pickData.split("-")
        sd = arr1[0] + "-" + (Number(arr1[1]) < 10 ? "0" + Number(arr1[1]) : Number(arr1[1])) + "-01"
        let date1 = new Date()
        let month = Number(arr1[1])
        date1.setYear(Number(arr1[0]))
        date1.setMonth(month < 12 ? month : 12)
        date1.setDate(0)
        if (month > 11) {
          lastDay = 31
        } else {
          lastDay = date1.getDate()
        }
        ed = arr1[0] + "-" + (Number(arr1[1]) < 9 ? "0" + Number(arr1[1]) : Number(arr1[1])) + "-" + lastDay
      }
      sf = this.startDateFlag
      ef = this.endDateFlag
      let filterValue = "&sd=" + sd + "&sf=" + sf + "&ed=" + ed + "&ef=" + ef
      let result = await this.getAppointData(filterValue)
      if (result.data && result.data.code === 1) {
        this.renderDatas(result)
      }
    },
    //渲染数据
    renderDatas(datas) {
      let selectedDatesContent = datas?.data?.data?.datas
      let selectedDates = datas?.data?.data?.dateStrs || []
      let selectedDateMap = datas?.data?.data?.dateStrsMap || []
      this.$changeOptionsEV(selectedDates, "selectedDates", false, null, this.ids, true)
      this.$changeOptionsEV(selectedDateMap, "selectedDateMap", false, null, this.ids, true)
      let activityLists = []
      if (selectedDatesContent && selectedDatesContent.length > 0) {
        for (let i = 0; i < selectedDatesContent.length; i++) {
          let list1 = {}
          if (selectedDatesContent[i][1] && selectedDatesContent[i][1].value) {
            list1.title = selectedDatesContent[i][1].value
          }
          // 开始日期和结束日期标志不一致，代表选择日期范围
          if(this.startDateFlag !== this.endDateFlag){
            if(selectedDatesContent[i][this.startDateFlag] && selectedDatesContent[i][this.startDateFlag].value){
              list1.timeStart = selectedDatesContent[i][this.startDateFlag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeStartStr = list1.timeStart.split(" ")[0]
            }
            if(selectedDatesContent[i][this.endDateFlag] && selectedDatesContent[i][this.endDateFlag].value){
              list1.timeEnd = selectedDatesContent[i][this.endDateFlag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeEndStr = list1.timeEnd.split(" ")[0]
            }
          }else{
            let flag = 6
            if(this.endDateFlag){
              flag = this.endDateFlag
            }else if(this.startDateFlag){
              flag = this.startDateFlag
            }
            if(selectedDatesContent[i][flag] && selectedDatesContent[i][flag].value){
              list1.time = selectedDatesContent[i][flag].value
              // 时间格式必须是 yyyy-MM-dd HH:mm:ss
              list1.timeStr = list1.time.split(" ")[0]
            }
          }
          if (list1 !== {}) {
            activityLists.push(list1)
          }
        }
      }
      this.$changeOptionsEV(activityLists, "activityLists", false, null, this.ids, true)
    },
    async getAppointData(filterValue) {
      return this.instance.get(this.restDataUrl + filterValue)
    },
    listenData(e) {
      const rectAttr = this.getRectAttribute(this.ids)
      let id = window.localStorage.getItem("page-v2-data-update-id")
      let appId = this.appId
      if (!appId) appId = rectAttr?.options?.appId
      if (e.key == "page-v2-general-data-type-add") {
        if (id == appId) {
          console.log("后台分类数据更新 :>>")
          this.getAllData()
        }
      }
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        if (id == appId) {
          console.log("后台配置或数据更新 :>>")
          this.getAllData()
        }
      }
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose(appId) {
      this.appId = appId
      window.addEventListener("storage", this.listenData)
    },
    onBeforeDataCenterUpdate() {
      this.localManual = false
      this.isLocal = true
    },
    onAfterDataCenterUpdate(source) {
      this.localManual = false
      this.source = source
      this.isLocal = source === 1
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.linkDataBtn:hover {
  cursor: pointer;
}
</style>
